<template>
  <div>
    <SupplierDialog @update="list" />

    <v-tabs v-model="tab">
      <v-tab value="0">Поставщики</v-tab>
      <v-tab v-for="item in tabs" v-bind:key="item.id" :value="item.id">{{
        item.name
      }}</v-tab>
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item value="0">
        <v-row justify="end" class="mb-4 ml-0 mr-0 mt-0" dense>
          <v-col cols="1"
            ><v-btn @click="openSupplierDialog" color="primary"
              >Создать</v-btn
            ></v-col
          >
        </v-row>
        <v-data-table-server
          :headers="headers"
          :items="suppliers"
          :items-length="totalItems"
          :loading="loading"
          :items-per-page="100"
          item-value="name"
          class="elevation-1"
          @update:options="options = $event"
          fixed-header
          height="300px"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="supplier-row" @click="get(item.props.title.id)">
                <span>{{ item.columns.name }}</span>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-window-item>
      <v-window-item v-for="item in tabs" v-bind:key="item.id" :value="item.id">
        <SupplierInfo :supplier="item.supplier" />
      </v-window-item>
    </v-window>
  </div>
</template>
<script>
import SupplierDialog from "@/components/Dialogs/SupplierDialog/SupplierDialog";
import { mapMutations, mapGetters } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SuppliersRepository = RepositoryFactory.get("suppliers");
import SupplierInfo from "@/components/Supplier/SupplierInfo";
export default {
  components: {
    SupplierDialog,
    SupplierInfo,
  },
  data() {
    return {
      suppliers: [],
      totalItems: 0,
      loading: false,
      headers: [
        {
          title: "Наименование",
          align: "start",
          sortable: false,
          key: "name",
        },
      ],
      options: {},
    };
  },
  created() {
    this.updateSupplierActiveTab("0");
  },
  watch: {
    options: {
      handler() {
        this.list();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations([
      "updateSupplierDialogVisible",
      "updateCurrentSupplier",
      "updateSupplierActiveTab",
    ]),
    openSupplierDialog() {
      this.updateSupplierDialogVisible(true);
    },
    async list() {
      const { page, itemsPerPage } = this.options;
      this.loading = true;
      const result = await SuppliersRepository.get(page, itemsPerPage);
      if (result) {
        if (result.data.status === "success") {
          this.suppliers = result.data.data.rows;
          this.totalItems = result.data.data.totalCount;
        }
      }
      await SuppliersRepository.updateMainSupplier();
      this.loading = false;
    },
    async get(id) {
      if (this.loading) return;
      this.loading = true;
      const result = await SuppliersRepository.getSingle(id);

      if (result) {
        if (result.data.status === "success") {
          let data = result.data.data;
          let oldDataTab = this.tabs.find((x) => x.id == data.id);

          if (oldDataTab) {
            oldDataTab.supplier = data;
            oldDataTab.id = data.id;
            oldDataTab.name = data.name;
          } else {
            this.tabs.push({ id: data.id, name: data.name, supplier: data });
          }
          this.updateCurrentSupplier(data);
          this.updateSupplierActiveTab(data.id);

          await SuppliersRepository.updateMainSupplier();
        }
      }
      this.loading = false;
    },
    showPagination() {
      return this.pagination.totalPages > 0;
    },
  },
  computed: {
    ...mapGetters(["currentSupplier", "tabs", "supplierActiveTab"]),
    tab: {
      get() {
        return this.supplierActiveTab;
      },
      set(newValue) {
        this.updateSupplierActiveTab(newValue);
      },
    },
  },
};
</script>
<style scoped>
.supplier-row {
  cursor: pointer;
}
.supplier-row:hover {
  background-color: #1697f6;
  color: #fff;
}
</style>
